<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      agents: [],
      accountsPayable: [],
      advancedPayments: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchMode: false,
      searchModel: "",
      currentStep: 1,
      circlesCount: 3,
      form: {
        name: "",
        name_en: "",
        address: "",
        address_en: "",
        comboEnabled: false,
        selectedOption: "",
        phone: "",
        payable_subaccount_id: null,
        prepayments_subaccount_id: null,
        payable: {
          enabled: false,
          value: 0,
        },
        prepayment: {
          enabled: false,
          value: 0,
        },
      },
      openModal: false,
      secondModal: false,
    };
  },
  computed: {
    progressWidth() {
      return ((this.currentStep - 1) / (this.circlesCount - 1)) * 100 + "%";
    },
    isFirstStep() {
      return this.currentStep === 1;
    },
    isLastStep() {
      return this.currentStep === this.circlesCount;
    },
  },
  methods: {
    addAgent() {
      // let locale = this.$i18n.locale;

      // var data = {
      //   title: "popups.add",
      //   inputs: [
      //     {
      //       model: "name",
      //       type: "text",
      //       label: "agents.name",
      //     },
      //     {
      //       model: "name_en",
      //       type: "text",
      //       label: "agents.name_en",
      //     },
      //     {
      //       model: "payable_subaccount_id",
      //       type: "select",
      //       options: (() => {
      //         return this.accountsPayable.map((data) => {
      //           return {
      //             value: data.sas_id,
      //             label: locale == "ar" ? data.sas_name : data.sas_name_en,
      //           };
      //         });
      //       })(),
      //       label: "agents.payable_account",
      //     },
      //     {
      //       model: "prepayments_subaccount_id",
      //       type: "select",
      //       options: (() => {
      //         return this.advancedPayments.map((data) => {
      //           return {
      //             value: data.sas_id,
      //             label: locale == "ar" ? data.sas_name : data.sas_name_en,
      //           };
      //         });
      //       })(),
      //       label: "agents.prepayments_account",
      //     },
      //     {
      //       model: "address",
      //       type: "text",
      //       label: "agents.address",
      //     },
      //     {
      //       model: "address_en",
      //       type: "text",
      //       label: "agents.address_en",
      //     },
      //     {
      //       model: "phone",
      //       type: "text",
      //       label: "agents.phone",
      //     },
      //   ],
      //   buttons: [
      //     {
      //       text: "popups.add",
      //       closer: true,
      //       color: "primary",
      //       handler: (obj) => {
      //         obj.code += " sup";
      //         this.http.post("agents", obj).then(() => {
      //           this.get(this.page);
      //         });
      //       },
      //     },
      //     {
      //       text: "popups.cancel",
      //       closer: true,
      //       color: "danger",
      //       handler: () => {
      //         console.log("Like Clicked");
      //       },
      //     },
      //   ],
      // };
      // this.popup.modal(data);
      const obj = {
        name: this.form.name,
        name_en: this.form.name_en,
        address: this.form.address,
        address_en: this.form.address_en,
        phone: this.form.phone,
        payable_subaccount_id: this.form.payable_subaccount_id,
        prepayments_subaccount_id: this.form.prepayments_subaccount_id,
        prepayment: this.form.prepayment,
        payable: this.form.payable,
      };
      this.http.post("agents", obj).then(() => {
        this.form = {};
        this.openModal = false;
        this.get(this.page);
      });
    },
    editAgent(app) {
      let locale = this.$i18n.locale;
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "name",
            type: "text",
            value: app.name,
            label: "agents.name",
            restrictions: { required: true },
          },
          {
            model: "name_en",
            type: "text",
            value: app.name_en,
            label: "agents.name_en",
            restrictions: { required: true },
          },
          {
            model: "payable_subaccount_id",
            type: "select",
            options: (() => {
              return this.accountsPayable.map((data) => {
                return {
                  value: data.sas_id,
                  label: locale == "ar" ? data.sas_name : data.sas_name_en,
                };
              });
            })(),
            label: "agents.payable_account",
            restrictions: { required: true },
          },
          {
            model: "prepayments_subaccount_id",
            type: "select",
            options: (() => {
              return this.advancedPayments.map((data) => {
                return {
                  value: data.sas_id,
                  label: locale == "ar" ? data.sas_name : data.sas_name_en,
                };
              });
            })(),
            label: "agents.prepayments_account",
            restrictions: { required: true },
          },
          {
            model: "address",
            type: "text",
            value: app.address,
            label: "agents.address",
          },
          {
            model: "address_en",
            type: "text",
            value: app.address_en,
            label: "agents.address_en",
          },
          {
            model: "phone",
            type: "text",
            value: app.phone,
            label: "agents.phone",
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            validate: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("agents/", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
      console.log("fffff", this.form);
      //         this.http.put("agents/", this.form.id, this.form).then(() => {
      //           this.get(this.page);
      //         });
    },
    deleteAgent(app) {
      var data = {
        title: "popups.delete",
        msg: "popups.deletemsg",
      };
      this.popup.confirm(data).then((res) => {
        if (res) {
          this.http.delete("agents", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },
    search() {
      this.searchMode = true;
      this.tot_pages = 0;
      this.http
        .post("agents/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
        })
        .then((res) => {
          this.agents = res.data;
          this.agents.forEach((agent, index) => {
            let code = (this.page - 1) * this.limit + index + 1;
            agent.code =
              "SUP-" +
              (code < 10
                ? "000" + code
                : code < 100
                ? "00" + code
                : code < 1000
                ? "0" + code
                : code);
          });
        });
    },
    cancelSearchMode() {
      this.searchModel = "";
      this.searchMode = false;
      this.get(this.page);
    },
    getAccounts() {
      this.http.get("agents/accounts/subledger").then((res) => {
        if (res.status) {
          this.accountsPayable = res.data[0]?.sub_accounts;
          this.advancedPayments = res.data[1]?.sub_accounts;
        }
      });
    },
    get(page) {
      console.log(page);
      this.http
        .post("agents/pagination", {
          limit: this.limit,
          page: page,
          id: parseInt(this.$route.params.id),
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.agents = res.data;
          this.agents.forEach((agent, index) => {
            let code = (this.page - 1) * this.limit + index + 1;
            agent.code =
              "SUP-" +
              (code < 10
                ? "000" + code
                : code < 100
                ? "00" + code
                : code < 1000
                ? "0" + code
                : code);
          });
        });
    },
    nextStep() {
      if (this.currentStep < this.circlesCount) {
        this.currentStep++;
        this.tryNext = false;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    handelEdit(agent) {
      this.form = {
        ...agent,
        payable: agent.payable || { enabled: false, value: 0 },
        prepayment: agent.prepayment || { enabled: false, value: 0 },
      };
      this.secondModal = true;
      this.currentStep = 1;
    },
    handleSelectChange() {
      // Reset both
      this.form.prepayment.enabled = false;
      this.form.payable.enabled = false;

      // Enable the selected one
      if (this.form.selectedOption === "prepayment") {
        this.form.prepayment.enabled = true;
      } else if (this.form.selectedOption === "payable") {
        this.form.payable.enabled = true;
      }
    },
  },
  created() {
    this.get(1);
    this.getAccounts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.payments.sub.suppliers')"
    />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <div class="search-box chat-search-box" style="width: 250px">
                <div class="position-relative">
                  <input
                    :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
                    @keyup="search()"
                    type="text"
                    class="form-control fa-lg text-light"
                    :placeholder="$t('salaryItems.search')"
                    v-model="searchModel"
                    style="background-color: #2a3042 !important"
                  />
                  <i class="bx bx-search-alt search-icon text-light"></i>
                  <button
                    @click="cancelSearchMode()"
                    v-if="searchMode"
                    class="btn-close text-light"
                    style="position: absolute; top: 12px; left: 250px"
                  ></button>
                </div>
              </div>
            </div>
            <div class="col-6" style="display: flex; justify-content: flex-end">
              <button
                type="button"
                @click="openModal = true"
                class="btn btn-light float-end mb-4"
              >
                <span
                  class="bx bxs-plus-circle float-end fa-2x"
                  style="color: #2a3042 !important"
                ></span>
              </button>
            </div>
          </div>

          <div class="table-responsive">
            <table
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead>
                <tr
                  class="text-light"
                  style="background-color: #2a3042 !important"
                >
                  <th scope="col">#</th>
                  <th scope="col">{{ $t("popups.code") }}</th>
                  <th scope="col">{{ $t("agents.name") }}</th>
                  <th scope="col">{{ $t("agents.address") }}</th>
                  <th scope="col">{{ $t("agents.phone") }}</th>
                  <th scope="col">{{ $t("agents.created") }}</th>
                  <th scope="col">{{ $t("agents.updated") }}</th>
                  <th scope="col">{{ $t("agents.operations") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(app, index) in agents" :key="app" class="">
                  <td>{{ index + 1 }}</td>
                  <td>{{ app?.code }}</td>
                  <td>{{ $i18n.locale == "ar" ? app?.name : app?.name_en }}</td>
                  <!-- <td>
                    {{
                      (
                        parseFloat(app?.totalCredit) -
                        parseFloat(app?.totalDebit)
                      ).toLocaleString()
                    }}
                  </td> -->
                  <td>
                    {{ $i18n.locale == "ar" ? app?.address : app?.address_en }}
                  </td>
                  <td>{{ app?.phone }}</td>
                  <td>{{ app.created?.split("T")[0] }}</td>
                  <td>{{ app.updated?.split("T")[0] }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      style="margin-inline-end: 4px"
                      @click="editAgent(app)"
                    >
                      {{ $t("popups.edit") }}
                    </button>

                    <button
                      class="btn btn-danger btn-sm"
                      href="javascript:void(0)"
                      role="button"
                      @click="deleteAgent(app)"
                    >
                      {{ $t("popups.delete") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--   Purchases  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
          p
        }}</a>
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->

    <!--Add modal-->
    <BModal
      hide-footer
      v-model="openModal"
      :title="$t('popups.add')"
      class="model-content"
      hide-close-header
    >
      <form @submit.prevent="addAgent()">
        <div class="row">
          <div class="col-6"></div>
          <div
            class="col-6"
            style="display: flex; justify-content: flex-end"
          ></div>
        </div>
        <div>
          <div class="progress-container mt-4">
            <div class="progress" :style="{ width: progressWidth }"></div>
            <div
              v-for="n in circlesCount"
              :key="n"
              class="circle"
              :class="{ active: n <= currentStep }"
            >
              {{ n }}
            </div>
          </div>
        </div>
        <div class="row stepper-content" v-show="currentStep === 1">
          <div class="mb-3 mt-4">
            <label for="exampleInputEmail1" class="form-label">
              {{ $t("agents.name") }}
            </label>
            <input
              required
              type="text"
              class="form-control"
              v-model="form.name"
            />
          </div>

          <div class="mb-3">
            <label for="exampleInputEmail1" class="form-check-label mx-2">
              {{ $t("agents.name_en") }}
            </label>
            <input
              required
              class="form-control"
              type="text"
              v-model="form.name_en"
            />
          </div>

          <div class="mb-3">
            <label for="exampleInputPassword1" class="form-label">
              {{ $t("agents.address") }}
            </label>
            <input
              type="text"
              v-model="form.address"
              class="form-control"
              id="exampleInputPassword1"
            />
          </div>
          <div class="mb-3">
            <label for="exampleInputPassword2" class="form-label">
              {{ $t("agents.address_en") }}
            </label>
            <input
              type="text"
              v-model="form.address_en"
              class="form-control"
              id="exampleInputPassword1"
            />
          </div>
          <div class="mb-3">
            <label for="exampleInputPassword3" class="form-label">
              {{ $t("agents.phone") }}
            </label>
            <input
              required
              type="number"
              v-model="form.phone"
              class="form-control"
            />
          </div>
        </div>
        <div class="row stepper-content" v-show="currentStep === 2">
          <div class="mb-3">
            <label for="exampleInputPassword1" class="form-label">
              {{ $t("agents.payable_account") }}
            </label>
            <select
              required
              class="form-select"
              aria-label="Default select example"
              v-model="form.payable_subaccount_id"
            >
              <option
                v-for="account in accountsPayable"
                :key="account.sas_id"
                :value="account.sas_id"
              >
                {{
                  $i18n.locale === "ar" ? account.sas_name : account.sas_name_en
                }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label for="exampleInputPassword1" class="form-label">
              {{ $t("agents.prepayments_account") }}
            </label>
            <select
              required
              class="form-select"
              aria-label="Default select example"
              v-model="form.prepayments_subaccount_id"
            >
              <option
                v-for="account in advancedPayments"
                :key="account.sas_id"
                :value="account.sas_id"
              >
                {{
                  $i18n.locale === "ar" ? account.sas_name : account.sas_name_en
                }}
              </option>
            </select>
          </div>
        </div>
        <div class="row stepper-content" v-show="currentStep === 3">
          <!-- <div class="mb-3">
          <div class="d-flex justify-content-between align-items-center">
              <div class="form-check d-flex  gap-2">
              <input class="form-check-input" type="checkbox" id="customCheck" v-model="form.payable.enabled" />
              <label class="form-label " for="customCheck">
                {{ $t('agents.payable') }}
              </label>
            </div>
            <div class="w-80">
              <currency-input class="form-control w-80"   v-model.number="form.payable.value" :disabled="!form.payable.enabled" />
            </div>
          </div>
      </div>
        <div class="mb-3">
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
                <div class="form-check d-flex gap-2">
                <input class="form-check-input" type="checkbox" id="customCheck1" v-model="form.prepayment.enabled" />
                <label class="form-label align-items-center" for="customCheck1">
                  {{ $t('agents.prepayment') }}
                </label>
              </div>
              <div class="w-80">
                <currency-input class="form-control w-80" v-model.number="form.prepayment.value" :disabled="!form.prepayment.enabled" min="0" />
              </div>
            </div>
          </div>
        </div> -->
          <div class="form-check d-flex gap-2 align-items-center mb-3">
            <input
              class="form-check-input m-1"
              type="checkbox"
              id="customCheckCombo"
              v-model="form.comboEnabled"
            />
            <label class="form-label mt-2" for="customCheckCombo">
              {{ $t("agents.enable_option") }}
            </label>
          </div>
          <div v-if="form.comboEnabled" class="mt-2">
            <!-- Select Input -->
            <select
              class="form-select mb-2"
              v-model="form.selectedOption"
              @change="handleSelectChange"
            >
              <option disabled value="">-- {{ $t("select") }} --</option>
              <option value="prepayment">{{ $t("agents.prepayment") }}</option>
              <option value="payable">{{ $t("agents.payable") }}</option>
            </select>

            <!-- Currency Input -->
            <currency-input
              class="form-control"
              v-if="form.comboEnabled"
              v-model.number="form[form.selectedOption || 'prepayment'].value"
              :placeholder="$t('agents.amount')"
              :min="0"
            />
          </div>
        </div>
        <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
          <button
            v-if="!isFirstStep"
            type="button"
            class="stepper-btn-back"
            id="prevBtn"
            @click="prevStep"
            :disabled="isFirstStep"
          >
            {{ $t("popups.go_back") }}
          </button>
          <button
            type="button"
            class="stepper-btn"
            id="nextBtn"
            @click="nextStep"
            v-show="!isLastStep"
          >
            {{ $t("popups.next") }}
          </button>
          <button type="submit" class="btn btn-primary">
            {{ $t("popups.add") }}
          </button>
          <button
            data-bs-dismiss="modal"
            type="button"
            class="btn btn-danger"
            @click="
              this.tryNext = false;
              form = {};
            "
          >
            {{ $t("popups.cancel") }}
          </button>
        </div>
      </form>
    </BModal>
  </Layout>
</template>
<style scoped>
.modal-content {
  z-index: -1;
}
.progress-container {
  display: flex;
  margin: 0 auto 30px;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 350px;
  max-width: 100%;
}
.progress-container::before {
  content: "";
  width: 100%;
  background-color: #f1f1f1;
  height: 5px;
  position: absolute;
  z-index: -1;
}
.progress {
  width: 0;
  background-color: green;
  height: 5px;
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  z-index: -1;
  transition: 0.4s ease-in-out;
}
.circle {
  background: #fff;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3px solid #f1f1f1;
  border-radius: 50px;
  z-index: 3;
}
.progress-container::before {
  z-index: 1;
}

.progress {
  z-index: 2;
}

.active {
  border-color: green;
  transition: 0.6s ease-in;
}
.stepper-btn {
  border: none;
  padding: 5px 8px;
  width: 80px;
  font-size: 14px;
  border-radius: 5px;
  background: green;
  color: #fff;
  cursor: pointer;
  line-height: 1.5rem;
}
.stepper-btn-back {
  border: none;
  padding: 5px 8px;
  width: 80px;
  font-size: 14px;
  border-radius: 5px;
  background: rgb(25, 26, 2);
  color: #fff;
  cursor: pointer;
  line-height: 1.5rem;
}
.modal-btn {
  padding: 5px 8px;
  width: 80px;
  font-size: 14px;
  border-radius: 5px;
}
.stepper-btn:disabled {
  background-color: #f1f1f1;
  cursor: not-allowed;
  color: #000;
}
</style>
